
export default function ServiceArea() {
  const regions = [
    {
      name: '関東',
      emoji: '🗼',
      areas: ['東京都', '神奈川県', '埼玉県', '千葉県', '茨城県', '栃木県', '群馬県']
    },
    {
      name: '東海',
      emoji: '🏔️',
      areas: ['愛知県', '静岡県', '岐阜県', '三重県']
    },
    {
      name: '北陸',
      emoji: '❄️',
      areas: ['富山県', '石川県', '福井県', '新潟県']
    },
    {
      name: '関西',
      emoji: '🏯',
      areas: ['大阪府', '兵庫県', '京都府', '奈良県', '滋賀県', '和歌山県']
    },
    {
      name: '中国',
      emoji: '⛩️',
      areas: ['広島県', '岡山県', '山口県', '鳥取県', '島根県']
    },
    {
      name: '四国',
      emoji: '🍊',
      areas: ['愛媛県', '香川県', '高知県', '徳島県']
    },
    {
      name: '九州',
      emoji: '🌋',
      areas: ['福岡県', '熊本県', '鹿児島県', '長崎県', '大分県', '宮崎県', '佐賀県', '沖縄県']
    },
  ];

  return (
    <section id="service-area" className="py-12 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-16">
          <div className="inline-flex items-center gap-2 bg-white text-teal-600 px-4 py-1.5 md:px-5 md:py-2 rounded-full text-xs md:text-sm font-semibold mb-4 md:mb-6 shadow-md border border-teal-100">
            <i className="ri-map-pin-line"></i>
            エリア情報
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-gray-800 mb-3 md:mb-4">
            対応エリア
          </h2>
          <div className="w-16 md:w-20 h-1 md:h-1.5 bg-gradient-to-r from-teal-400 to-emerald-400 mx-auto mt-4 md:mt-6 rounded-full"></div>
        </div>

        <div className="bg-gradient-to-br from-teal-50 to-emerald-50 rounded-2xl md:rounded-3xl p-5 md:p-12 border border-teal-100 mb-8 md:mb-12">
          <div className="text-center mb-6 md:mb-10">
            <div className="flex items-center justify-center gap-2 md:gap-3 mb-2 md:mb-3">
              <span className="text-2xl md:text-3xl">🗾</span>
              <h3 className="text-lg md:text-2xl font-bold text-gray-800">
                関西全域を中心に幅広く対応
              </h3>
            </div>
            <p className="text-gray-600 text-sm md:text-base">
              お客様のエリアに合わせて、迅速かつ丁寧なサポートを提供いたします
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5 mb-6 md:mb-10">
            {regions.map((region, index) => (
              <div
                key={index}
                className="bg-white rounded-xl md:rounded-2xl p-4 md:p-5 shadow-sm border border-teal-100 hover:shadow-md transition-all duration-300"
              >
                <div className="flex items-center gap-2 mb-3">
                  <span className="text-xl md:text-2xl">{region.emoji}</span>
                  <h4 className="text-sm md:text-base font-bold text-teal-600">{region.name}</h4>
                </div>
                <div className="flex flex-wrap gap-1.5">
                  {region.areas.map((area, aIdx) => (
                    <span
                      key={aIdx}
                      className="bg-teal-50 text-teal-700 text-[10px] md:text-xs font-medium px-2 py-0.5 rounded-full border border-teal-100"
                    >
                      {area}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="bg-white rounded-xl md:rounded-2xl p-4 md:p-6 border border-teal-200">
            <div className="flex items-center gap-3 md:gap-4">
              <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-full flex items-center justify-center shadow-md">
                <span className="text-xl md:text-2xl">🚗</span>
              </div>
              <div>
                <h4 className="text-sm md:text-lg font-bold text-gray-800 mb-0.5 md:mb-1">
                  訪問対応も可能です！
                </h4>
                <p className="text-gray-600 text-xs md:text-sm leading-relaxed">
                  <span className="text-teal-500 font-medium">関西全域（大阪・兵庫・滋賀・和歌山・奈良・京都）</span>はもちろん、
                  <span className="text-teal-500 font-medium">三重・岐阜・愛知エリア</span>にも訪問対応可能です！
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center">
          <p className="text-gray-500 text-xs md:text-sm mb-1 md:mb-2 flex items-center justify-center gap-2">
            <i className="ri-information-line text-teal-400"></i>
            その他のエリアについてもお気軽にご相談ください
          </p>
          <p className="text-[10px] md:text-xs text-gray-400">
            ※対応可能エリアは順次拡大中です
          </p>
        </div>
      </div>
    </section>
  );
}
